import React, { Component } from 'react';
import './App.css';
import { Layout, Header, Navigation, Drawer, Content } from 'react-mdl';
import Main from './components/main';
import { Link } from 'react-router-dom';

class App extends Component {
  render() {
    return (
      <div className="demo-big-content">
    <Layout >
        <Header  className="header-color" title={<Link  style={{textDecoration: 'none', color: 'white' /* Animation */
}} to="/">MyPortfolio</Link>} scroll>
            <Navigation >
                <Link className="zoom" to="/resume">Resume</Link>
                <Link className="zoom" to="/aboutme">About Me</Link>
                <Link className="zoom" to="/projects">Projects</Link>
                <Link className="zoom" to="/contact">Contact</Link>
                <Link className="zoom" to="/Recommandations">Recommandations</Link>

            </Navigation>
        </Header>
        <Drawer title={<Link style={{textDecoration: 'none', color: 'black'}} to="/">MyPortfolio</Link>}>
            <Navigation>
              <Link to="/resume">Resume</Link>
              <Link to="/aboutme">About Me</Link>
              <Link to="/projects">Projects</Link>
              <Link to="/contact">Contact</Link>
              <Link to="/Recommandations">Recommandations</Link>
            </Navigation>
        </Drawer>
        <Content>
            <div className="page-content" />
            <Main/>
        </Content>
    </Layout>
</div>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js